import { Storage } from "utils/storage";

import { ACTIVITY_HEALTH_LEVELS, ActivityHealthLevel } from "./activityHealth";

export type ActivityTrendSeverity = "all" | ActivityHealthLevel;

export const activityTrendStorage = new Storage<
    "localStorage",
    "controlHealth",
    "activityTrendSeverity",
    ActivityTrendSeverity
>({
    type: "localStorage",
    namespace: "controlHealth",
    codecs: {
        encodeKey: (key) => key,
        encodeValue: (value) => value,
        decodeValue: (value) =>
            ACTIVITY_HEALTH_LEVELS.find(({ key }) => key === value)?.key ??
            "all",
    },
});
